// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".tabStyling .css-1wf8b0h-MuiTabs-flexContainer {\n    justify-content: flex-start !important;\n}", "",{"version":3,"sources":["webpack://./src/components/CrmServices/DynamicTabs/tabStyle.css"],"names":[],"mappings":"AAAA;IACI,sCAAsC;AAC1C","sourcesContent":[".tabStyling .css-1wf8b0h-MuiTabs-flexContainer {\n    justify-content: flex-start !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
